module.exports = __webpack_public_path__ + "static/media/resume.03f72ea1.pdf";